// extracted by mini-css-extract-plugin
module.exports = {"slideCentered":"Carousel_slideCentered__Co6jf"};